<div class="oase-shop">
  <mat-card appearance="outlined">
<!--      <mat-card-title>{{ 'Shop.hauszustellung' | translate:locale.language }}</mat-card-title>-->
      <mat-card-content>
        <div class="shop_heading">{{ 'Shop.heading' | translate:locale.language }}</div>
        <div class="shop_row1">{{ 'Shop.row1' | translate:locale.language }}</div>
        <div class="shop_row2">{{ 'Shop.row2' | translate:locale.language }}</div>
        <div class="shop_row3">{{ 'Shop.row3_1' | translate:locale.language }} <a href='tel:004342538124'>04253 8124</a> {{ 'Shop.row3_2' | translate:locale.language }}</div>
        <div id='collection-component-1581329430185' class="shop_container">
          <div class="shop_show_loading">{{ 'Shop.loading' | translate:locale.language }}</div>
        </div>
        <div class="shop_footer_asterix">{{ 'Shop.footer_asterix' | translate:locale.language }}</div>
        <div class="shop_footer_dsgvo">{{ 'Shop.footer_dsgvo' | translate:locale.language }}</div>
      </mat-card-content>
    </mat-card>
</div>
